import styled, { css } from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	gap: 20px;
	user-select: none;
`;

const StyledButtonContainer = styled.div<{ $clickable?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 10px;
	border-radius: 10px;
	background-color: ${(props) =>
		props.$clickable
			? 'rgba(255, 255, 255, 0.1)'
			: 'rgba(255, 255, 255, 0.05)'};
	transition: background-color 0.25s ease;

	${(props) =>
		props.$clickable &&
		css`
			&:hover {
				cursor: pointer;
				background-color: #fff;
			}

			&:hover {
				> div:first-child {
					color: #fff;
					background-color: #000;
				}

				> div:last-child {
					color: #000;
				}
			}
		`}
`;

const StyledButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 20px;
	height: 20px;
	padding: 0 5px;
	font-family: 'GT Walsheim Pro';
	font-weight: bold;
	font-size: 12px;
	color: #000;
	border-radius: 6px;
	background-color: #fff;
	transition:
		color 0.25s ease,
		background-color 0.25s ease;
`;

const StyledButtonIcon = styled(StyledButton)`
	padding: 0;
`;

const StyledLabel = styled.div`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	color: #fff;
	line-height: 18px;
	transition: color 0.25s ease;
`;

const StyledIcon = styled.div<{ $icon: string }>`
	width: 20px;
	height: 20px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${(props) => props.$icon});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${(props) => props.$icon});
	background-color: #000000;
`;

export {
	StyledContainer,
	StyledButtonContainer,
	StyledButton,
	StyledLabel,
	StyledIcon,
	StyledButtonIcon,
};
